import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { blogArticles, blogCategories } from '../../mocks/blog-articles';

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('Tous les articles');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredArticles = blogArticles.filter(article => {
    const matchesCategory = selectedCategory === 'Tous les articles' || article.category === selectedCategory;
    const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         article.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const featuredArticles = blogArticles.filter(article => article.featured);

  useEffect(() => {
    window.scrollTo(0, 0);

    // SEO Meta Tags
    document.title = 'Blog Intelligence Artificielle Paris - Guides Agents IA & Automatisation | AgentIA Pro';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez nos guides experts sur les agents IA, l\'automatisation intelligente et la transformation digitale. Articles pratiques sur agents IA conversationnels, chatbots intelligents et solutions d\'intelligence artificielle pour entreprises à Paris. Conseils d\'experts en IA.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Découvrez nos guides experts sur les agents IA, l\'automatisation intelligente et la transformation digitale. Articles pratiques sur agents IA conversationnels, chatbots intelligents et solutions d\'intelligence artificielle pour entreprises à Paris. Conseils d\'experts en IA.';
      document.head.appendChild(meta);
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'blog IA Paris, guides agents IA, automatisation intelligente, transformation digitale IA, chatbot intelligent conseils, agents IA conversationnels guide, intelligence artificielle entreprise blog, tutoriels IA France, articles IA experts Paris');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'blog IA Paris, guides agents IA, automatisation intelligente, transformation digitale IA, chatbot intelligent conseils, agents IA conversationnels guide, intelligence artificielle entreprise blog, tutoriels IA France, articles IA experts Paris';
      document.head.appendChild(meta);
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`);
      document.head.appendChild(canonical);
    }

    // Last Modified
    let lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    } else {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('name', 'last-modified');
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
      document.head.appendChild(lastModified);
    }

    // Open Graph Tags
    const ogTags = [
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog` },
      { property: 'og:title', content: 'Blog Intelligence Artificielle Paris - Guides Agents IA & Automatisation' },
      { property: 'og:description', content: 'Guides experts sur les agents IA, l\'automatisation intelligente et la transformation digitale. Articles pratiques sur agents IA conversationnels et solutions d\'intelligence artificielle pour entreprises.' },
      { property: 'og:image', content: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog-og-image.jpg` }
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    });

    // Twitter Tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Blog Intelligence Artificielle Paris - Guides Agents IA' },
      { name: 'twitter:description', content: 'Guides experts sur les agents IA, l\'automatisation intelligente et la transformation digitale pour entreprises.' },
      { name: 'twitter:image', content: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog-twitter-image.jpg` }
    ];

    twitterTags.forEach(({ name, content }) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    });

    // Schema.org JSON-LD
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Blog AgentIA Pro",
      "description": "Blog expert sur les agents IA, l'automatisation intelligente et la transformation digitale des entreprises",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "AgentIA Pro",
        "logo": {
          "@type": "ImageObject",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`
        }
      },
      "blogPost": blogArticles.slice(0, 10).map(article => ({
        "@type": "BlogPosting",
        "headline": article.title,
        "description": article.excerpt,
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog/${article.slug}`,
        "datePublished": article.publishedAt,
        "author": {
          "@type": "Person",
          "name": article.author.name
        },
        "image": article.image
      }))
    });
    document.head.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Blog Intelligence Artificielle
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Découvrez nos guides, analyses et conseils d'experts sur les agents IA, l'automatisation intelligente et la transformation digitale des entreprises
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto relative">
            <input
              type="text"
              placeholder="Rechercher un article, un sujet..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-6 py-4 pr-12 rounded-full border-2 border-gray-200 focus:border-teal-500 focus:outline-none text-base"
            />
            <i className="ri-search-line absolute right-6 top-1/2 -translate-y-1/2 text-xl text-gray-400"></i>
          </div>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="py-8 px-6 border-b border-gray-200 sticky top-0 bg-white z-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
            {blogCategories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full whitespace-nowrap text-sm font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      {selectedCategory === 'Tous les articles' && searchQuery === '' && (
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Articles à la Une</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/blog/${article.slug}`}
                  className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
                >
                  <div className="relative h-56 w-full overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-teal-600 text-white text-xs font-semibold rounded-full">
                        À la Une
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-medium text-teal-600">{article.category}</span>
                      <span className="text-xs text-gray-400">•</span>
                      <span className="text-xs text-gray-500">{article.readTime}</span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
                        <img
                          src={article.author.avatar}
                          alt={article.author.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">{article.author.name}</p>
                        <p className="text-xs text-gray-500">{article.author.role}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* All Articles */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-3xl font-bold text-gray-900">
              {selectedCategory === 'Tous les articles' ? 'Tous les Articles' : selectedCategory}
            </h2>
            <p className="text-sm text-gray-500">
              {filteredArticles.length} article{filteredArticles.length > 1 ? 's' : ''}
            </p>
          </div>

          {filteredArticles.length === 0 ? (
            <div className="text-center py-16">
              <i className="ri-article-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-xl text-gray-500">Aucun article trouvé</p>
              <p className="text-sm text-gray-400 mt-2">Essayez de modifier vos critères de recherche</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/blog/${article.slug}`}
                  className="group bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-teal-500 hover:shadow-lg transition-all duration-300"
                >
                  <div className="relative h-48 w-full overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-medium text-teal-600">{article.category}</span>
                      <span className="text-xs text-gray-400">•</span>
                      <span className="text-xs text-gray-500">{article.readTime}</span>
                      <span className="text-xs text-gray-400">•</span>
                      <span className="text-xs text-gray-500">
                        {new Date(article.publishedAt).toLocaleDateString('fr-FR', { 
                          day: 'numeric', 
                          month: 'long', 
                          year: 'numeric' 
                        })}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-md"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                      <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center">
                        <img
                          src={article.author.avatar}
                          alt={article.author.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div>
                        <p className="text-xs font-medium text-gray-900">{article.author.name}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-20 px-6 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto text-center">
          <i className="ri-mail-line text-5xl text-white/80 mb-6"></i>
          <h2 className="text-4xl font-bold text-white mb-4">
            Restez Informé des Dernières Tendances IA
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Recevez nos meilleurs articles et guides directement dans votre boîte mail
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Votre adresse email"
              className="flex-1 px-6 py-4 rounded-full text-base focus:outline-none focus:ring-2 focus:ring-white"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-white text-teal-600 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              S'abonner
            </button>
          </form>
          <p className="text-sm text-white/70 mt-4">
            Pas de spam. Désinscription possible à tout moment.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}